module.exports = __webpack_public_path__ + "ad59a65e08ee02b7ffd339c865f4db5a.pdf";